import React, { useState } from 'react';
import { API_BASE_URL, fetchWithCsrf } from '../../../config/api';
import HubPageLayout from '../components/HubPageLayout';
import FramedPanel from '../components/FramedPanel';
import AiPill from '../components/AiPill';


const DashboardSupport = () => {

  


  const [activeTab, setActiveTab] = useState('ticket');
  
  // Form state for ticket submission
  const [ticketForm, setTicketForm] = useState({
    name: '',
    email: '',
    subject: '',
    description: ''
  });

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTicketForm({
      ...ticketForm,
      [name]: value
    });
  };

  // Handle ticket submission — POSTs to /bff/support/tickets, which stores the
  // ticket and emails the intake mailbox. Previously this only console.logged.
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleSubmitTicket = async (e) => {
    e.preventDefault();
    if (!ticketForm.description.trim()) return;
    setSubmitting(true);
    setSubmitError(null);
    try {
      const r = await fetchWithCsrf(`${API_BASE_URL}/bff/support/tickets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: ticketForm.name.trim() || null,
          email: ticketForm.email.trim() || null,
          subject: ticketForm.subject.trim() || null,
          description: ticketForm.description.trim(),
        }),
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d.errors?.[0]?.msg || d.error || 'Failed to submit');
      }
      setSubmitted(true);
      setTicketForm({ name: '', email: '', subject: '', description: '' });
    } catch (err) {
      setSubmitError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  // Tab navigation component
  const TabButton = ({ tabId, label, isActive, onClick }) => (
    <button
      className={`px-6 py-4 font-medium transition-all duration-200 border-b-2 -mb-px ${
        isActive
          ? 'text-blue-600 border-blue-600 bg-white'
          : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
      }`}
      onClick={() => onClick(tabId)}
    >
      {label}
    </button>
  );

  if (submitted) {
    return (
      <HubPageLayout>
        <div className="border-2 border-black mt-10 p-6 min-h-[380px]">
          <AiPill>We got it.</AiPill>
          <p className="text-3xl text-black mt-10 px-2 leading-snug">
            Your information has been forwarded to our support team.
          </p>
        </div>
      </HubPageLayout>
    );
  }

  return (
    <HubPageLayout>
      <FramedPanel title="Support">
        <div className="px-6 pt-8 pb-6">
          <div className="relative">
            <img
              src="/images/my-noscam/support-hero.jpeg"
              alt=""
              className="w-full h-[280px] object-cover"
            />
            <p className="absolute inset-y-0 left-0 flex items-center pl-8 pr-4 max-w-sm text-white text-lg leading-relaxed">
              General questions? Technical needs? Our US-based Member Care team is here to assist.
            </p>
          </div>
        </div>
      </FramedPanel>

      {/* Content Section - Original Support Content */}
      <div className="px-6 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
       

        {/* Support Content Section with Tabs */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          {/* Tab Navigation */}
          <div className="flex border-b border-gray-200 bg-gray-50">
            <TabButton
              tabId="ticket"
              label="Submit a Ticket"
              isActive={activeTab === 'ticket'}
              onClick={setActiveTab}
            />
            <TabButton
              tabId="chat"
              label="Live Chat Support"
              isActive={activeTab === 'chat'}
              onClick={setActiveTab}
            />
            <TabButton
              tabId="phone"
              label="Phone Support"
              isActive={activeTab === 'phone'}
              onClick={setActiveTab}
            />
          </div>
          
          {/* Tab Content */}
          <div className="p-8">
            {/* Submit a Ticket Tab */}
            {activeTab === 'ticket' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    Submit a Support Ticket
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    Fill out the form below to submit a support ticket. Our team will review your request and get back to you within 24-48 hours via email.
                  </p>
                  
                  <form onSubmit={handleSubmitTicket} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={ticketForm.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={ticketForm.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Subject
                      </label>
                      <input
                        type="text"
                        name="subject"
                        value={ticketForm.subject}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Description
                      </label>
                      <textarea
                        name="description"
                        value={ticketForm.description}
                        onChange={handleInputChange}
                        required
                        rows={6}
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none"
                      />
                    </div>
                    
                    <button
                      type="submit"
                      disabled={submitting || !ticketForm.description.trim()}
                      className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-md transition-all duration-300 disabled:opacity-50"
                    >
                      {submitting ? 'Sending…' : 'Submit Ticket'}
                    </button>
                    {submitError && <p className="text-red-600 mt-3">{submitError}</p>}
                  </form>
                </div>
                
                <div className="flex flex-col justify-center">
                  <div className="text-center mb-8">
                    <img 
                      src="/mockup_images/marketing-remodel/Dashboard/support/image47.png" 
                      alt="Help Desk Support"
                      className="w-full max-w-sm mx-auto h-auto"
                    />
                  </div>
                  
                  <div className="bg-blue-50 p-6 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-3">What to expect:</h4>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li>• Response within 24-48 hours</li>
                      <li>• Detailed investigation of your issue</li>
                      <li>• Clear resolution steps or workarounds</li>
                      <li>• Follow-up to ensure satisfaction</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* Live Chat Support Tab */}
            {activeTab === 'chat' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Live Chat Support
                  </h3>
                  <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg mb-6">
                    <p className="text-yellow-800">
                      <strong>Note:</strong> Live chat support is coming soon. Please submit a ticket for assistance at this time.
                    </p>
                  </div>
                  
                  <button
                    disabled
                    className="border-gray-300 text-gray-400 cursor-not-allowed py-3 px-8 rounded-md border bg-white"
                  >
                    Start Live Chat Now
                  </button>
                </div>
                
                <div className="flex flex-col justify-center">
                  <div className="text-center">
                    <img 
                      src="/mockup_images/marketing-remodel/Dashboard/support/image47.png" 
                      alt="Live Chat Support"
                      className="w-full max-w-sm mx-auto h-auto"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Phone Support Tab */}
            {activeTab === 'phone' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Phone Support
                  </h3>
                  <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg mb-6">
                    <p className="text-yellow-800">
                      <strong>Note:</strong> Phone support is coming soon. Please submit a ticket for assistance at this time.
                    </p>
                  </div>
                  
                  <button
                    disabled
                    className="border-gray-300 text-gray-400 cursor-not-allowed py-3 px-8 rounded-md border bg-white"
                  >
                    Call Support Now
                  </button>
                </div>
                
                <div className="flex flex-col justify-center">
                  <div className="text-center">
                    <img 
                      src="/mockup_images/marketing-remodel/Dashboard/support/image47.png" 
                      alt="Phone Support"
                      className="w-full max-w-sm mx-auto h-auto"
                    />
                  </div>
                </div>
              </div>
            )}
          
          </div>
        </div>
        </div>
      </div>
      </div>

    </HubPageLayout>
  );

};

export default DashboardSupport;
